import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

export class NotificationDialogData {
  title?:string
  text?:string

  posBtn?:string
  negBtn?:string
  checkboxText?:string
}

@Component({
  selector: 'notification-dialog',
  templateUrl: './notification-dialog.html'
})
export class NotificationDialog {

  checkboxValue:boolean

  constructor(public dialogRef: MatDialogRef<NotificationDialog>, @Inject(MAT_DIALOG_DATA) public data: NotificationDialogData ) {

  }

  onClick(isPos:boolean): void {
    this.dialogRef.close({response:isPos,checkboxValue:this.checkboxValue})
  }

}
